import React, { useState } from "react";
import "./order-details.css";
import { useNavigate } from "react-router-dom";

function Cancelorderpopup({ onClose }) {
  const navigate = useNavigate();
  
  const [reason, setReason] = useState("");
  const [otherReason, setOtherReason] = useState(""); // To handle the text input for "Others"
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    navigate('/return-products-final');
    onClose();
  };

  const handleReasonChange = (e) => {
    setReason(e.target.value);
    if (e.target.value !== "Others") {
      setOtherReason(""); // Clear textarea if other reason is not selected
    }
  };

  return (
    <div className="cancel_order_popup">
      <div className="popup_inner">
        <h5>Why do you want to cancel the order?</h5>
        <form onSubmit={handleSubmit}>
          <div className="form_group">
            <ul>
              <li>
                <input
                  type="radio"
                  id="reason_1"
                  name="cancel_reason"
                  value="Order placed by mistake"
                  onChange={handleReasonChange}
                />{" "}
                Order placed by mistake
              </li>
              <li>
                <input
                  type="radio"
                  id="reason_2"
                  name="cancel_reason"
                  value="Ordered wrong item"
                  onChange={handleReasonChange}
                />{" "}
                Ordered wrong item
              </li>
              <li>
                <input
                  type="radio"
                  id="reason_3"
                  name="cancel_reason"
                  value="Need to change shipping address"
                  onChange={handleReasonChange}
                />{" "}
                Need to change shipping address
              </li>
              <li>
                <input
                  type="radio"
                  id="reason_4"
                  name="cancel_reason"
                  value="Need to change payment method"
                  onChange={handleReasonChange}
                />{" "}
                Need to change payment method
              </li>
              <li>
                <input
                  type="radio"
                  id="reason_5"
                  name="cancel_reason"
                  value="Item price too high"
                  onChange={handleReasonChange}
                />{" "}
                Item price too high
              </li>
              <li>
                <input
                  type="radio"
                  id="reason_6"
                  name="cancel_reason"
                  value="Others"
                  onChange={handleReasonChange}
                />{" "}
                Others
              </li>
            </ul>
          </div>

          {/* Show the textarea when "Others" is selected */}
          {reason === "Others" && (
            
              <textarea
                placeholder="Type your Reason"
                value={otherReason}
                onChange={(e) => setOtherReason(e.target.value)}
                className="textarea_other_reason"
              
              />
           
          )}

          <div>
            <button type="submit" style={{ width: "100%" }} className="btn_1">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Cancelorderpopup;
